/* eslint-disable no-unused-vars */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Palette } from 'config';

import * as S from './Buttons.styled';

const Buttons = () => {};

const PrimaryNormal = forwardRef(
  (
    {
      children,
      id,
      type = 'button', // 'button', 'submit', 'reset' - used with forms
      name, // used with forms
      form, // used with forms
      onClick,
      style,
      icon,
      isDisabled,
      customTag,
    },
    ref,
  ) => {
    return (
      <S.PrimaryNormal
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        // isPressed={isPressed}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.PrimaryNormal>
    );
  },
);

const PrimarySmall = forwardRef(
  (
    { children, id, type = 'button', name, form, onClick, style, icon, isDisabled, customTag },
    ref,
  ) => {
    return (
      <S.PrimarySmall
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        // isPressed={isPressed}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.PrimarySmall>
    );
  },
);

const SecondaryNormal = forwardRef(
  (
    {
      children,
      id,
      type = 'button',
      name,
      form,
      onClick,
      style,
      icon,
      isPressed,
      isDisabled,
      customTag,
    },
    ref,
  ) => {
    return (
      <S.SecondaryNormal
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        isPressed={isPressed}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.SecondaryNormal>
    );
  },
);

const SecondarySmall = forwardRef(
  (
    {
      children,
      id,
      type = 'button',
      name,
      form,
      onClick,
      style,
      icon,
      isPressed,
      isDisabled,
      customTag,
    },
    ref,
  ) => {
    return (
      <S.SecondarySmall
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        isPressed={isPressed}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.SecondarySmall>
    );
  },
);

const TertiaryNormal = forwardRef(
  (
    {
      children,
      id,
      type = 'button',
      name,
      form,
      onClick,
      style,
      icon,
      isPressed,
      isDisabled,
      isMuted,
      isDestructive,
      customTag,
    },
    ref,
  ) => {
    return (
      <S.TertiaryNormal
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        isPressed={isPressed}
        isMuted={isMuted}
        isDestructive={isDestructive}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.TertiaryNormal>
    );
  },
);

const TertiarySmall = forwardRef(
  (
    {
      children,
      id,
      type = 'button',
      name,
      form,
      onClick,
      style,
      icon,
      isPressed,
      isDisabled,
      isMuted,
      isDestructive,
      customTag,
    },
    ref,
  ) => {
    return (
      <S.TertiarySmall
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        isPressed={isPressed}
        isMuted={isMuted}
        isDestructive={isDestructive}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.TertiarySmall>
    );
  },
);

const QuaternaryNormal = forwardRef(
  (
    {
      children,
      id,
      type = 'button',
      name,
      form,
      onClick,
      style,
      icon,
      isPressed,
      isDisabled,
      isMuted,
      customTag,
    },
    ref,
  ) => {
    return (
      <S.QuaternaryNormal
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        isPressed={isPressed}
        isMuted={isMuted}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.QuaternaryNormal>
    );
  },
);

const DestructiveNormal = forwardRef(
  (
    { children, id, type = 'button', name, form, onClick, style, icon, isDisabled, customTag },
    ref,
  ) => {
    return (
      <S.DestructiveNormal
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.DestructiveNormal>
    );
  },
);

const DestructiveSmall = forwardRef(
  (
    { children, id, type = 'button', name, form, onClick, style, icon, isDisabled, customTag },
    ref,
  ) => {
    return (
      <S.DestructiveSmall
        id={id}
        style={style}
        type={type}
        name={name}
        form={form}
        ref={ref}
        disabled={isDisabled}
        onClick={onClick}
        as={customTag}
      >
        {icon}
        {children}
      </S.DestructiveSmall>
    );
  },
);

PrimaryNormal.displayName = 'PrimaryNormal';
PrimarySmall.displayName = 'PrimarySmall';
SecondaryNormal.displayName = 'SecondaryNormal';
SecondarySmall.displayName = 'SecondarySmall';
TertiaryNormal.displayName = 'TertiaryNormal';
TertiarySmall.displayName = 'TertiarySmall';
QuaternaryNormal.displayName = 'QuaternaryNormal';
DestructiveNormal.displayName = 'DestructiveNormal';
DestructiveSmall.displayName = 'DestructiveSmall';

Buttons.PrimaryNormal = PrimaryNormal;
Buttons.PrimarySmall = PrimarySmall;
Buttons.SecondaryNormal = SecondaryNormal;
Buttons.SecondarySmall = SecondarySmall;
Buttons.TertiaryNormal = TertiaryNormal;
Buttons.TertiarySmall = TertiarySmall;
Buttons.QuaternaryNormal = QuaternaryNormal;
Buttons.DestructiveNormal = DestructiveNormal;
Buttons.DestructiveSmall = DestructiveSmall;

const buttonTypes = {
  PrimaryNormal: 'PrimaryNormal',
  PrimarySmall: 'PrimarySmall',
  SecondaryNormal: 'SecondaryNormal',
  SecondarySmall: 'SecondarySmall',
  TertiaryNormal: 'TertiaryNormal',
  TertiarySmall: 'TertiarySmall',
  QuaternaryNormal: 'QuaternaryNormal',
  DestructiveNormal: 'DestructiveNormal',
  DestructiveSmall: 'DestructiveSmall',
};

Buttons.buttonTypes = buttonTypes;

export default Buttons;
